import { render, staticRenderFns } from "./v-footer-address.vue?vue&type=template&id=8d3e0d22&scoped=true&"
var script = {}
import style0 from "./v-footer-address.vue?vue&type=style&index=0&id=8d3e0d22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3e0d22",
  null
  
)

export default component.exports